// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import questionReviewerEntity from './entities/question-reviewer.json';
import questionReviewerMenu from '../pages/question-reviewer/menu.json';
import questionReviewerFullForm from '../pages/question-reviewer/forms/full.json';
import questionReviewerContextForm from '../pages/question-reviewer/forms/context.json';
import questionReviewerMiniForm from '../pages/question-reviewer/forms/mini.json';
import questionReviewerLookupForm from '../pages/question-reviewer/forms/lookup.json';
import questionReviewerTableView from '../pages/question-reviewer/views/table.json';
import questionReviewerCardsView from '../pages/question-reviewer/views/cards.json';
import questionReviewerDashboardView from '../pages/question-reviewer/views/dashboard.json';

/** Тип запису «Юрист-рецензент» зі сторінками пакета: меню, форми та подання з pages/question-reviewer/. */
export const questionReviewerDefinition: IRecordTypeDefinition = {
  ...questionReviewerEntity,
  views: assembleViewSet({
      table: questionReviewerTableView,
      cards: questionReviewerCardsView,
      dashboard: questionReviewerDashboardView,
  }),
  form: questionReviewerFullForm,
  forms: { full: questionReviewerFullForm, context: questionReviewerContextForm, mini: questionReviewerMiniForm, lookup: questionReviewerLookupForm },
  menu: questionReviewerMenu,
} as IRecordTypeDefinition;
